import { render, staticRenderFns } from "./graph-legend-percentage.vue?vue&type=template&id=41ffded0&scoped=true"
import script from "./graph-legend-percentage.vue?vue&type=script&lang=js"
export * from "./graph-legend-percentage.vue?vue&type=script&lang=js"
import style0 from "./graph-legend-percentage.vue?vue&type=style&index=0&id=41ffded0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ffded0",
  null
  
)

export default component.exports